import { store } from "../../../store/store";
import { setOrderStatus } from "./OMSUtils";

export const getOrderSnackBarData = () => {
    let orderList = []
    const _reduxState: any = store.getState();
    if (_reduxState.orderList && _reduxState.orderList.length > 0)
        orderList = _reduxState.orderList
    else return []
    var latestActiveOrder = [], latestRateOrder = []
    var sortedOrderList = JSON.parse(JSON.stringify(orderList));
    // sortedOrderList.sort((order1, order2) => {
    //     var genId1 = 0, genId2 = 0
    //     if (order1 && order1['gen']) genId1 = order1['gen']
    //     if (order2 && order2['gen']) genId2 = order2['gen']
    //     return genId2 - genId1
    // })
    sortedOrderList?.forEach(order => {
        order = setOrderStatus(order)
        if (order['isActiveOrder'])
            latestActiveOrder.push(order)
        else if (!order['isCancelOrder'] && !order['feedback'])
            latestRateOrder.push(order)

    });
    latestActiveOrder = latestActiveOrder.slice(0, 6)
    latestRateOrder = latestRateOrder.slice(0, 6)
    if (latestActiveOrder.length) latestActiveOrder.sort((order1, order2) => {
        var genId1 = 0, genId2 = 0
        if (order1 && order1['gen']) genId1 = order1['gen']
        if (order2 && order2['gen']) genId2 = order2['gen']
        return genId2 - genId1
    })
    if (latestRateOrder.length) latestRateOrder.sort((order1, order2) => {
        var genId1 = 0, genId2 = 0
        if (order1 && order1['gen']) genId1 = order1['gen']
        if (order2 && order2['gen']) genId2 = order2['gen']
        return genId2 - genId1
    })
    var snackBarOrderList = [...latestActiveOrder, ...latestRateOrder]
    return snackBarOrderList.slice(0, 6)
}
